module.exports = __webpack_public_path__ + "static/img/3.52410a07.png";